<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Ingreso de Nota de Crédito de Compra Manualmente</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Compras</span>
      <span> /</span>
      <span>Ingreso de Nota de Crédito de Compra Manualmente</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- CABECERA -->
<form autocomplete="off" [formGroup]="formData" (ngSubmit)="buscar(1)">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body">
      
      <div class="d-flex justify-content-between">
        <div>
          <div class="row filtros-body">
            <div class="col" style="max-width: 150px">
              <div class="md-form mb-2">
                <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required formControlName="fechaDesde"> </mdb-date-picker>
                <div *ngIf="formData.get('fechaDesde').invalid && (formData.get('fechaDesde').dirty || formData.get('fechaDesde').touched)">
                  <mdb-error *ngIf="formData.get('fechaDesde').hasError('required')"> Ingrese fecha desde </mdb-error>
                </div>
              </div>
            </div>
    
            <div class="col" style="max-width: 150px">
              <div class="md-form mb-2">
                <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required formControlName="fechaHasta"> </mdb-date-picker>
                <div *ngIf="formData.get('fechaHasta').invalid && (formData.get('fechaHasta').dirty || formData.get('fechaHasta').touched)">
                  <mdb-error *ngIf="formData.get('fechaHasta').hasError('required')"> Ingrese fecha hasta </mdb-error>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button size="sm" mdbBtn type="submit" class="btn btn-sm" color="secondary"  mdbWavesEffect>
          <mdb-icon fas icon="search"></mdb-icon>
          Buscar
        </button>
      </div>

      

    </div>

  </div>
  <!-- FIN de CABECERA -->

  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="table-responsive">
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">Folio</th>
              <th scope="col">Doc. Referencia</th>
              <th scope="col">RUT</th>
              <th scope="col">Detalle Emisor</th>
              <th scope="col">Fecha Emi.</th>
              <th scope="col">Fecha Venc.</th>
              <th scope="col">Monto</th>
              <th scope="col">Tipo Devolución</th>
              <th scope="col">Motivo</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="100%" style="text-align: center" *ngIf="loading">
                <mdb-spinner spinnerColor="blue"></mdb-spinner>
              </td>
              <td colspan="100%" style="text-align: center" *ngIf="!loading && listaMovimientos?.length === 0">No se encontró información</td>
            </tr>
            <tr *ngFor="let doc of listaMovimientos">
              <td>{{ doc.folio }}</td>
              <td>{{ doc.folio_referencia }}</td>
              <td>{{ doc.rutFormato | rut }}</td>
              <td>{{ doc.cliente_proveedor_nombre }}</td>
              <td>{{ doc.fecha_registro | fecha }}</td>
              <td>{{ doc.fecha_vencimiento | fecha }}</td>
              <td>{{ doc.monto_total | numerico }}</td>
              <td>{{ doc.tipo_devolucion }}</td>
              <td>{{doc.motivo_devolucion_nombre}}</td>
            </tr>
          </tbody>
          <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)" *ngIf="listaMovimientos?.length > 0"></app-pagination>
        </table>
      </div>
    </div>
  </div>

  <div class="card mb-2 wow">
    <div class="card-body d-sm-flex p-1 flex-end">
      <button size="sm" class="btn btn-sm" mdbBtn type="button" color="info" (click)="OpenAnulacionDoc()" mdbWavesEffect>Nota de Credito por Anulacion</button>
      <button size="sm" class="btn btn-sm" mdbBtn type="button" color="info" (click)="OpenModalAgregarDoc()" mdbWavesEffect>Nota de Credito por Correcion de Monto o Parcial</button>
    </div>
  </div>

  <!-- MODAL AGREGAR DOCUMENTO -->
  <app-modal-agregar-documento-nota-credito (onExecuteBuscar)="getItemToSearch($event)"> </app-modal-agregar-documento-nota-credito>

  <!-- MODAL ANULACION DOCUMENTO -->
  <app-modal-anulacion-doc (onExecuteBuscar)="getItemToSearch($event)"></app-modal-anulacion-doc>
</form>
